import { render, staticRenderFns } from "./VendorProfile.vue?vue&type=template&id=3048024a"
import script from "./VendorProfile.vue?vue&type=script&lang=js"
export * from "./VendorProfile.vue?vue&type=script&lang=js"
import style0 from "./VendorProfile.vue?vue&type=style&index=0&id=3048024a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports